var ValueJS = ValueJS || {};

ValueJS.Countdown = function() {

    var _init = function() {

        $('.countdown').each(function() {
            let timer = $(this);
            let deadline = new Date(timer.data('deadline')).getTime();
            _update(timer, deadline);
            let intervalId = setInterval(_update, 1000, timer, deadline);
        });

    }

    var _update = function(timer, deadline) {
        let now = new Date().getTime();
        let timeLeft = deadline - now;

        // calculate
        var days = 0;
        var hours = 0;
        var minutes = 0;
        var seconds = 0;

        if (timeLeft > 0) {
            days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
            hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
            seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
        }

        // update HTML
        timer.find('.countdown__days').text(days);
        timer.find('.countdown__hours').text(hours);
        timer.find('.countdown__minutes').text(minutes);
        timer.find('.countdown__seconds').text(seconds);
    }


    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    ValueJS.Countdown.init();
});
